import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL, createAuthHeader } from '../../../config/api.config';

const useExperimentPerformance = (experimentId, clientId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!experimentId || !clientId) {
      setData(null);
      return;
    }

    let cancelled = false;
    const fetchPerformance = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('access_token');
        const searchParams = new URLSearchParams();
        searchParams.append('clientId', clientId);
        searchParams.append('baseline', 'historical');
        searchParams.append('experimentIds', experimentId);

        const response = await axios.get(
          `${API_BASE_URL}/experiments/overview/group-details?${searchParams.toString()}`,
          { headers: createAuthHeader(token) }
        );

        if (!cancelled) {
          const experiments = response.data.experiments || [];
          setData(experiments[0] || null);
        }
      } catch (error) {
        console.error('Error fetching experiment performance:', error);
        if (!cancelled) setData(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchPerformance();
    return () => { cancelled = true; };
  }, [experimentId, clientId]);

  return { data, loading };
};

export default useExperimentPerformance;
